import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import CardItem from "./CardItem";
import NewCard from "./NewCard";
import { useIsFocused } from "@react-navigation/native";
import * as Colors from "../styles/colors"
import { formatMoneyBRL } from "../helpers/util";
import { DeleteCard, GetPaymentMethods } from "../services/Api/card";
import { GlobalContext } from "../contexts/global";
import { PaymentContext } from "../contexts/payment";
import FractionAmount from "./FractionAmount";
import { Fonts } from "../styles";

export default function PaymentFormList({ totalAmount, hasWallets = true, hasFractions = false }) {
  const { setLoading, showAlert, setShowAlert } = useContext(GlobalContext);
  const { setSelectedPaymentForm,
    newCard,
    setNewCard,
    saveCard,
    setSaveCard,
    cardNumber,
    setCardNumber,
    validCardNumber,
    cardExpiration,
    setCardExpiration,
    validCardExpiration,
    cardCvv,
    setCardCvv,
    validCardCvv,
    cardName,
    setCardName,
    validCardName,
    cardDocument,
    validCardDocument,
    setCardDocument } = useContext(PaymentContext);

  const [cardList, setCardList] = useState([]);
  const [creditWallet, setCreditWallet] = useState({ value: 0 });
  const [sharedCreditWallet, setSharedCreditWallet] = useState({ value: 0 });
  const [fractions, setFractions] = useState({ value: 0 })
  const [fractionsShared, setFractionsShared] = useState({ value: 0 })
  const [showModalFractionAmount, setShowModalFractionAmount] = useState({ show: false, idFraction: 0 })
  const [checked, setChecked] = useState("");
  const [fractionAmount, setFractionAmount] = useState(1)
  const [fractionValue, setFractionValue] = useState(0.00)
  const isFocus = useIsFocused()
  useEffect(() => {
    if (isFocus) {
      updateList()
    }
  }, [isFocus])

  const deleteCardApi = (idCard) => {
    setLoading({ show: true, message: "Removendo o cartão..." });
    DeleteCard(idCard)
      .then((value) => {
        updateList();
      })
      .catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Erro ao excluir cartão",
          message: value.error,
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "Removendo o cartão." });
      });
  };

  const deleteCard = (cardNumber, idCard) => {
    setShowAlert({
      type: "warning",
      title: "Atenção",
      message: `Deseja realmente deletar o cartão de final ${cardNumber.substring(
        12,
        16
      )} ?`,
      show: true,
      confirmText: "Sim",
      cancelText: "Não",
      pressCancel: () => {
        setShowAlert({ ...showAlert, show: false });
      },
      pressConfirm: () => {
        deleteCardApi(idCard);
        setShowAlert({ ...showAlert, show: false });
      },
      showConfirmButton: true,
    });
  };

  const updateList = () => {
    GetPaymentMethods()
      .then((value) => {
        setCardList(value.data.creditCardResponses);
        setCreditWallet({
          id: value.data.walletResponse.id,
          value: value.data.walletResponse.value,
        });
        setSharedCreditWallet(
          {
            id: value.data.walletResponse.walletSharedResponse.id,
            value: value.data.walletResponse.walletSharedResponse.value,
          }
        )
        if (hasFractions) {
          setFractions(value.data.walletResponse.fractions)
          setFractionsShared(value.data.walletResponse.walletSharedResponse.fractions)
        }
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: (error.erro ?? erro.message) ?? "Erro ao tentar carregar os cartões",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "" });
      });
  };

  const handlePaymentForm = (paymentForm, fractionAmount = 0) => {
    let selectedPaymentForm;
    let payType = 0 //Credit
    let idFraction = null
    let amountFraction = null

    if (paymentForm == "wallet") payType = 1;
    else if (paymentForm == "walletShared") payType = 2;
    else if (paymentForm.includes("fractionId")) {
      payType = 3;
      idFraction = paymentForm.replace("fractionId:", "")
      amountFraction = fractionAmount
    }
    else selectedPaymentForm = cardList.find((card) => card.cardNumber === paymentForm);
    setChecked(paymentForm);
    setSelectedPaymentForm({ ...selectedPaymentForm, payType: payType, idFraction: idFraction, amountFraction: amountFraction });
  };

  const props = {
    cardNumber,
    setCardNumber,
    validCardNumber,
    cardExpiration,
    setCardExpiration,
    validCardExpiration,
    cardCvv,
    setCardCvv,
    validCardCvv,
    cardName,
    setCardName,
    validCardName,
    cardDocument,
    validCardDocument,
    setCardDocument
  };
  totalAmount = totalAmount.toString().replace(",", ".")
  const sharedWalletEnable = !!totalAmount && sharedCreditWallet.value >= totalAmount
  const walletEnable = !!totalAmount && creditWallet.value >= totalAmount

  return (
    <ScrollView keyboardShouldPersistTaps={"always"} style={{ width: "100%" }} contentContainerStyle={styles.viewSecundaria}>
      {hasWallets ? <View>
        <CardItem
          text={`Carteira ${formatMoneyBRL(creditWallet.value)}`}
          onPressCard={() => {
            if (walletEnable) {
              handlePaymentForm("wallet");
              setNewCard(false);
              setFractionAmount(1)
            }
          }}
          hasSelect={walletEnable}
          style={{
            backgroundColor: walletEnable ? Colors.WALLET : Colors.GRAY_DARK,
            borderColor: Colors.BLACK,
            width: "100%",
          }}
          iconName={"wallet"}
          iconColor={Colors.WHITE}
          iconSize={36}
          textStyle={{ color: Colors.WHITE, fontWeight: "500" }}
          checked={checked == "wallet" && !newCard}
        />
        {(sharedCreditWallet.id ?? 0) > 0 ? <CardItem
          text={`Compartilhado: ${formatMoneyBRL(sharedCreditWallet.value)}`}
          onPressCard={() => {
            if (sharedWalletEnable) {
              handlePaymentForm("walletShared");
              setNewCard(false);
            }
          }}
          hasSelect={sharedWalletEnable}
          style={{
            backgroundColor: sharedWalletEnable ? Colors.SECONDARY : Colors.GRAY_DARK,
            borderColor: Colors.BLACK,
            width: "100%",
          }}
          iconName={"wallet-outline"}
          iconColor={Colors.WHITE}
          iconSize={36}
          textStyle={{ color: Colors.WHITE, fontWeight: "500" }}
          checked={checked == "walletShared" && !newCard}
        /> : null}
      </View>
        : null}
      {fractions.length > 0 ? fractions.map((fraction) => {
        return (
          <CardItem
            text={`Fração: ${formatMoneyBRL(fraction.value)}`}
            onPressCard={() => {
              setFractionAmount(1)
              setShowModalFractionAmount({ show: true, fractionId: fraction.id, value: fraction.value })
              setNewCard(false);
            }}
            hasSelect={true}
            style={{
              backgroundColor: Colors.WARNING,
              borderColor: Colors.BLACK,
              width: "100%",
            }}
            iconName={"pie-chart"}
            iconColor={Colors.WHITE}
            iconSize={32}
            iconType={"feather"}
            textStyle={{ color: Colors.WHITE, fontWeight: "500" }}
            checked={checked == `fractionId:${fraction.id}` && !newCard}
            key={`fracaoId${fraction.id}`}
          />
        );
      }) : null}
      {fractionsShared.length > 0 ? fractionsShared.map((fraction) => {
        return (
          <CardItem
            text={`Fração comp.: ${formatMoneyBRL(fraction.value)}`}
            onPressCard={() => {
              setFractionAmount(1)
              setShowModalFractionAmount({ show: true, fractionId: fraction.id, value: fraction.value })
              setNewCard(false);
            }}
            hasSelect={true}
            style={{
              backgroundColor: Colors.PRIMARY,
              borderColor: Colors.BLACK,
              width: "100%",
            }}
            iconName={"pie-chart"}
            iconColor={Colors.WHITE}
            iconSize={32}
            iconType={"feather"}
            textStyle={{ color: Colors.WHITE, fontWeight: "500" }}
            checked={checked == `fractionId:${fraction.id}` && !newCard}
            key={`fracaoId${fraction.id}`}
          />
        );
      }) : null}
      {cardList.length > 0 ? cardList.map((card) => {
        return (
          <CardItem
            cardBrand={card.brand}
            cardNumber={card.cardNumber}
            key={card.cardNumber}
            checked={checked == card.cardNumber && !newCard}
            style={{ flexGrow: 1, width: "100%" }}
            onPressCard={() => {
              setFractionAmount(1)
              handlePaymentForm(card.cardNumber);
              setNewCard(false);
            }}
            onPressDelete={() => deleteCard(card.cardNumber, card.idCard)}
            hasSelect={!!totalAmount}
          />
        );
      }) : null}
      <NewCard
        newCard={newCard}
        setNewCard={setNewCard}
        unityInfo={totalAmount}
        props={props}
        handleSelectedCard={() => handlePaymentForm("newCard")}
        saveCard={saveCard}
        setSaveCard={setSaveCard}
      />
      {
        checked.includes("fractionId") ?
          <View style={{ alignItems: "center" }}>
            <Text style={styles.textFraction}>{`Quantidade de frações: ${fractionAmount}`}</Text>
            <Text style={styles.textFraction}>{`Total a ser pago: ${formatMoneyBRL(fractionAmount * fractionValue)}`}</Text>
          </View>
          : null
      }
      <FractionAmount
        modalVisible={showModalFractionAmount}
        setModalVisible={setShowModalFractionAmount}
        onPress={(amount) => {
          setFractionAmount(amount)
          setFractionValue(showModalFractionAmount.value)
          handlePaymentForm(`fractionId:${showModalFractionAmount.fractionId}`, amount);
        }}
      />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  textFraction: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK
  }
});
